// This input is used to select a year in the term form
import FormSelect from './FormSelect'
import moment from 'moment'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: this.years,
        ...this.config,
      }
    },
    normalizedOptions () {
      return this.mergedConfig.options || []
    },
    years () {
      return Array(5)
        .fill(null)
        .map((_, index) => {
          // Starting with a previous year
          const year = moment().add(index - 1, 'year')
          return `${year.format('YYYY')}-${year.add(1, 'year').format('YY')}`
        })
    },
  },
}
